const dom = require('../utils/DOM');
const env = require('../utils/ENV');
const Router = require('../helpers/Router');
const SlickSliders = require('../modules/SlickSliders');

function MainPage() {
	if (dom.$body.hasClass('home')) {
		this.init();
		if (env.isDesktop) {
			this.initDesktop();
		} else {
			this.initMobile();
		}
	}
}

MainPage.prototype = {
	init: function() {
		this.wpData = wpData; // eslint-disable-line
		this.loadUrlMagazines = this.wpData.afterload.frontMagazines;
		this.loadUrlBiblio = this.wpData.afterload.frontBiblio;
		this.biblioSlug = this.wpData.lib_slug;
		this.pageCounterMagazines = 1;
		this.pageCounterBiblio = 1;
		this.allLoadMagazines = 0;
		this.allLoadBiblio = 0;
		this.groupSize = 6;

		this.$primary = $('#primary');
		this.$librarySection = this.$primary.find('.librarySection');
		this.$magazineSection = this.$primary.find('.magazineSection');
		this.$articleList = this.$librarySection.find('.articles-list');
		this.$magazineList = this.$magazineSection.find('.magazine-list');
		this.$footer = $('.site-footer');
	},
	groupArray: function(array) {
		let groupArray = [];
		for (let i = 0; i < Math.ceil(array.length / this.groupSize); i++) {
			groupArray[i] = array.slice(i * this.groupSize, i * this.groupSize + this.groupSize);
		}
		return groupArray;
	},
	loadDataMagazines: function() {
		if (!this.allLoadMagazines) {
			this.pageCounterMagazines += 1;
			const self = this;
			$.ajax({
				url: self.loadUrlMagazines + self.pageCounterMagazines,
				success: function(response, status, jqXHR) {
					if (env.isDesktop) {
						self.$magazineSection.removeClass('_loading');
					} else {
						self.$primary.removeClass('_loading');
					}
					if (jqXHR.status == 200) {
						if (env.isDesktop) {
							self.addNewDesktop(response.html);
						} else {
							let groupArray = [];
							for (let i = 0; i < Math.ceil(response.html.length / self.groupSize); i++) {
								groupArray[i] = response.html.slice(
									i * self.groupSize,
									i * self.groupSize + self.groupSize
								);
							}
							self.loadDataBiblio(groupArray);
						}
					} else if (jqXHR.status == 204) {
						self.allLoad('magazine');
						if (env.isDesktop) {
							self.$magazineSection.addClass('_loaded');
						} else {
							self.$primary.addClass('_loaded');
						}
					} else {
						console.log(jqXHR);
						self.errorLoad('magazine');
					}
				},
				error: function(response) {
					console.log(response);
					self.errorLoad('magazine');
					if (env.isDesktop) {
						self.$magazineSection.removeClass('_loading');
					} else {
						self.$primary.removeClass('_loading');
					}
				},
			});
		}
	},
	loadDataBiblio: function(responseMagazines) {
		if (!this.allLoadBiblio) {
			this.pageCounterBiblio += 1;
			const self = this;
			$.ajax({
				url: self.loadUrlBiblio + self.pageCounterBiblio,
				success: function(response, status, jqXHR) {
					if (env.isDesktop) {
						self.$librarySection.removeClass('_loading');
					} else {
						self.$primary.removeClass('_loading');
					}
					if (jqXHR.status == 200) {
						if (env.isDesktop) {
							self.addNewDesktop(false, response.html);
						} else {
							let groupArray = [];
							for (let i = 0; i < Math.ceil(response.html.length / self.groupSize); i++) {
								groupArray[i] = response.html.slice(
									i * self.groupSize,
									i * self.groupSize + self.groupSize
								);
							}
							self.addNewMobile(responseMagazines, groupArray);
						}
					} else if (jqXHR.status == 204) {
						self.allLoad('library');
						if (env.isDesktop) {
							self.$librarySection.addClass('_loaded');
						} else {
							self.$primary.addClass('_loaded');
						}
					} else {
						console.log(jqXHR);
						self.errorLoad('library');
					}
				},
				error: function(response) {
					console.log(response);
					self.errorLoad('library');
					if (env.isDesktop) {
						self.$librarySection.removeClass('_loading');
					} else {
						self.$primary.removeClass('_loading');
					}
				},
			});
		}
	},
	allLoad: function(type) {
		if (type == 'magazine') {
			this.allLoadMagazines = 1;
		} else {
			this.allLoadBiblio = 1;
		}
	},
	errorLoad: function(type) {
		if (type == 'magazine') {
			this.pageCounterMagazines -= 1;
		} else {
			this.pageCounterBiblio -= 1;
		}
	},

	initDesktop: function() {
		this.$libraryLinkContainer = $('#menu-item-lib');
		this.$magazineLinkContainer = $('#menu-item-mag');
		this.$libraryLinkArea = this.$libraryLinkContainer.find('a');
		this.$magazineLinkArea = this.$magazineLinkContainer.find('a');
		this.$librarySectionLink = this.$librarySection.find('#libLink');
		this.$magazineSectionLink = this.$magazineSection.find('#magLink');
		this.$siteHeader = $('.site-header');
		this.$siteContent = $('.site-content');
		this.$articleLoad = this.$articleList.find('.load-more__btn');
		this.$magazineLoad = this.$magazineList.find('.load-more__btn');

		this.hiddenBlockWidth = 640;
		this.change = 0;
		this.$marker =
			window.location.pathname == `/${this.biblioSlug}` ||
			window.location.pathname == `/${this.biblioSlug}/`
				? 'library'
				: 'magazine';

		// this.initFooter();
		this.changeScreen(this.$marker);
		addEventListener('popstate', e => {
			e.preventDefault();
			this.$marker = window.location.pathname == `/${this.biblioSlug}` ? 'library' : 'magazine';
			this.changeScreen(this.$marker);
		});

		this.$siteHeader.on('hover', () => {
			if (dom.$window.width() <= '896') {
				if (this.$magazineSection.position().left !== 0) {
					this.change = 128;
					this.$magazineSection.css(
						'left',
						`calc(-${this.hiddenBlockWidth}px + calc(4em + ${this.change}px))`
					);
				}
			}
		});
		this.$siteHeader.on('mouseleave', () => {
			if (dom.$window.width() <= '896') {
				if (this.$magazineSection.position().left !== 0) {
					this.change = 0;
					this.$magazineSection.css('left', `calc(-${this.hiddenBlockWidth}px + 4em)`);
				}
			}
		});

		this.$articleLoad.on('click', () => {
			this.$librarySection.addClass('_loading');
			this.loadDataBiblio();
		});
		this.$magazineLoad.on('click', () => {
			this.$magazineSection.addClass('_loading');
			this.loadDataMagazines();
		});

		// dom.$window.on('resize orientationchange', () => {
		// 	this.updateFooter();
		// });
	},
	initMobile: function() {
		this.$container = $('#primary');
		const $magazineListItems = this.$magazineList.find('.magazine-list-item');
		let responseMagazines = [];
		for (let i = 0; i < $magazineListItems.length; i++) {
			const $item = $magazineListItems.eq(i).prop('outerHTML');
			responseMagazines.push($item);
		}
		responseMagazines = this.groupArray(responseMagazines);

		const $articleListItems = this.$articleList.find('.articles-list-item');
		let responseBiblio = [];
		for (let i = 0; i < $articleListItems.length; i++) {
			const $item = $articleListItems.eq(i).prop('outerHTML');
			responseBiblio.push($item);
		}
		responseBiblio = this.groupArray(responseBiblio);
		const $loadMore = this.$magazineList.find('.load-more').prop('outerHTML');
		this.$articleList.remove();
		this.$magazineList.remove();
		this.$primary.append('<div class="inner-list-js"></div>');
		this.$primary.append($loadMore);
		this.addNewMobile(responseMagazines, responseBiblio);

		SlickSliders.rebuild();

		this.$loadMobile = this.$primary.find('.load-more__btn');

		this.$loadMobile.on('click', () => {
			this.$primary.addClass('_loading');
			this.loadDataBiblio();
		});

		// this.initFooter();
	},

	addNewDesktop: function(responseMagazines, responseBiblio) {
		let templateMagazines = '';
		for (let i = 0; i < responseMagazines.length; i++) {
			templateMagazines += responseMagazines[i];
		}
		this.$magazineList.find('.inner-list-js').append(templateMagazines);

		if (responseBiblio) {
			let templateBiblio = '';
			for (let i = 0; i < responseBiblio.length; i++) {
				templateBiblio += responseBiblio[i];
			}
			this.$articleList.find('.inner-list-js').append(templateBiblio);
		}

		// setTimeout(() => this.updateFooter(), 100);
	},
	addNewMobile: function(responseMagazines, responseBiblio) {
		let template = '';
		for (let i = 0; i < responseMagazines.length || i < responseBiblio.length; i++) {
			const blockMagazines = responseMagazines[i];
			const blockBiblio = responseBiblio[i];
			if (blockMagazines) {
				template +=
					'<section class="magazineSection"><div class="magazine-list _slider" data-slider="magazineList"><div data-slider-slides>';
				for (let j = 0; j < blockMagazines.length; j++) {
					const item = blockMagazines[j];
					template += item;
				}
				template += '</div></div></section>';
			}

			if (blockBiblio) {
				template += '<section class="librarySection"><div class="articles-list">';
				for (let j = 0; j < blockBiblio.length; j++) {
					const item = blockBiblio[j];
					template += item;
				}
				template += '</div></section>';
			}
		}
		this.$primary.find('.inner-list-js').append(template);
		SlickSliders.rebuild();
	},

	moveLeft: function(dir) {
		//Анимация блока "Журналы" влево
		if (dir === 0) {
			this.$magazineSection.css({ left: '-8em' });
			this.setHoverState('.librarySection');
		} else {
			this.$magazineSection.css({ left: '0' });
			this.resetHoverState('.librarySection');
		}
	},
	moveRight: function(dir) {
		//Анимация блока "Журналы" вправо
		const e = window.event;
		let X = e.pageX; // положения по оси X
		let Y = e.pageY; // положения по оси Y
		if (dir === 0) {
			this.$magazineSection.css(
				'left',
				`calc(-${this.hiddenBlockWidth}px + calc(4em + 128px + ${this.change}px))`
			);
		} else {
			this.$magazineSection.css(
				'left',
				`calc(-${this.hiddenBlockWidth}px + calc(4em + ${this.change}px))`
			);
		}
		return dir === 0
			? this.setHoverState('.magazineSection')
			: this.resetHoverState('.magazineSection');
	},
	setHoverState: function(el) {
		//установка Hover состояния для смежных эелементов - при наведении на боковые плашки и соответствующие пункты меню
		$(el).css({
			background:
				'linear-gradient(0deg, rgba(251, 235, 224, 0.2), rgba(251, 235, 224, 0.2)), #FEFDFC',
		});
		$(`${el} > .vert-title > p`).css('color', '#EB5160');
		$(`${el} > .vert-title > .arrow`).css('opacity', '1');
		this.$magazineSection.css('box-shadow', '8px 0px 16px #FBEBE0');
	},
	resetHoverState: function(el) {
		//сброс Hover состояния
		$(el).css({ background: '#FBEBE0' });
		$(`${el} > .vert-title > p`).css('color', '#171615');
		$(`${el} > .vert-title > .arrow`).css('opacity', '0');
		this.$magazineSection.css('box-shadow', 'none');
	},
	moveLibBlocksFunc: function() {
		this.$librarySection.on('mouseenter', () => {
			this.moveLeft(0);
			return false;
		});
		this.$librarySectionLink.on('mouseenter', () => {
			this.moveLeft(0);
			return false;
		});
		this.$libraryLinkArea.on('mouseenter', () => {
			this.moveLeft(0);
			return false;
		});
		this.$librarySection.on('mouseleave', () => {
			this.moveLeft(1);
			return false;
		});
		this.$libraryLinkArea.on('mouseleave', () => {
			this.moveLeft(1);
			return false;
		});
		this.$librarySection.on('click', e => {
			e.preventDefault();
			this.changeScreen('library');
		});
		this.$libraryLinkArea.on('click', e => {
			e.preventDefault();
			this.changeScreen('library');
		});
		this.$librarySectionLink.on('click', e => {
			e.preventDefault();
			this.changeScreen('library');
		});
	},
	moveMagBlocksFunc: function() {
		this.$magazineSection.on('mouseenter', () => {
			this.moveRight(0);
			return false;
		});
		this.$magazineSectionLink.on('mouseenter', () => {
			this.moveRight(0);
			return false;
		});
		this.$magazineLinkArea.on('mouseenter', () => {
			this.moveRight(0);
			return false;
		});
		this.$magazineSection.on('mouseleave', () => {
			this.moveRight(1);
			return false;
		});
		this.$magazineLinkArea.on('mouseleave', () => {
			this.moveRight(1);
			return false;
		});
		this.$magazineSection.on('click', e => {
			e.preventDefault();
			this.changeScreen('magazine');
			return false;
		});
		this.$magazineLinkArea.on('click', e => {
			e.preventDefault();
			this.changeScreen('magazine');
			return false;
		});
		this.$magazineSectionLink.on('click', e => {
			e.preventDefault();
			this.changeScreen('library');
		});
	},
	changeScreen: function(marker) {
		//Смена экрана между "Журналы"/"Библиотека"
		this.$marker = marker;
		if (marker === 'library') {
			this.$librarySection.addClass('_active');
			this.$magazineSection.removeClass('_active');
			this.change =
				$(window).width() > '896' ||
				($(window).width() <= '896' && $('.site-header').width() != '224')
					? 0
					: 128;
			this.$magazineSection.css({
				background: '#FBEBE0',
				left: `calc(-${this.hiddenBlockWidth}px + calc(4em + ${this.change}px))`,
				cursor: 'pointer',
				width: `${this.hiddenBlockWidth}px`,
			});
			this.$librarySection.css({ background: '#FEFDFC', cursor: 'default' });
			this.$librarySectionLink.css('opacity', '0');
			this.$magazineSectionLink.css({ opacity: '1', width: '4em' });

			this.$librarySection.unbind();
			this.$libraryLinkArea.unbind();
			this.$librarySectionLink.unbind();

			this.moveMagBlocksFunc();

			this.$articleList.css({ 'pointer-events': 'auto' });
			this.$magazineList.css('pointer-events', 'none');
			this.resetHoverState('.magazineSection');
		} else {
			this.$librarySection.removeClass('_active');
			this.$magazineSection.addClass('_active');
			this.$libraryLinkArea.removeClass();
			this.$magazineLinkArea.addClass();
			this.$magazineSectionLink.css({ opacity: '0', width: '0' });
			this.$magazineSection.css({
				background: '#FEFDFC',
				left: '0',
				width: 'calc(100% - 4em)',
				cursor: 'default',
				'box-shadow': 'none',
			});
			this.$librarySection.css({ background: '#FBEBE0', cursor: 'pointer' });

			this.$librarySectionLink.css('opacity', '1');

			this.$magazineSection.unbind();
			this.$magazineLinkArea.unbind();
			this.$magazineSectionLink.unbind();

			this.moveLibBlocksFunc();

			this.$articleList.css({ 'pointer-events': 'none' });
			this.$magazineList.css('pointer-events', 'auto');
			this.resetHoverState('.librarySection');
		}

		// this.updateFooter();
		this.updateNav();
	},
	updateNav: function() {
		if (this.$marker === 'library') {
			this.$libraryLinkContainer.addClass('current-menu-item');
			this.$magazineLinkContainer.removeClass('current-menu-item');
			if (window.location.pathname != this.$librarySectionLink.attr('href')) {
				Router.set(this.$librarySectionLink.attr('href'));
			}
		} else {
			this.$libraryLinkContainer.removeClass('current-menu-item');
			this.$magazineLinkContainer.addClass('current-menu-item');
			if (window.location.pathname != this.$magazineSectionLink.attr('href')) {
				Router.set(this.$magazineSectionLink.attr('href'));
			}
		}
	},
	initFooter: function() {
		if (env.isDesktop) {
			this.$footer.addClass('_fixed');
			this.$articleList.on('orientationchange scroll', () => {
				this.checkFooterDesktop();
			});
			this.$magazineList.on('orientationchange scroll', () => {
				this.checkFooterDesktop();
			});
		}

		this.updateFooter();
	},
	updateFooter: function() {
		if (env.isDesktop) {
			this.$footerHeight = this.$footer.outerHeight();
			this.$articleList.css('paddingBottom', this.$footerHeight + 40);
			this.$magazineList.css('paddingBottom', this.$footerHeight + 40);

			this.$libraryScroll = this.$articleList[0].scrollHeight;
			this.$libraryHeight = this.$articleList.eq(0).outerHeight();
			this.$magazineScroll = this.$magazineList[0].scrollHeight;
			this.$magazineHeight = this.$magazineList.outerHeight();

			this.checkFooterDesktop();
		}
	},
	checkFooterDesktop: function() {
		this.$libraryScroll = this.$articleList[0].scrollHeight;
		this.$magazineScroll = this.$magazineList[0].scrollHeight;
		let delta, scroll;
		if (this.$marker == 'library') {
			delta = this.$libraryScroll - this.$libraryHeight;
			scroll = this.$articleList.scrollTop();
		} else {
			delta = this.$magazineScroll - this.$magazineHeight;
			scroll = this.$magazineList.scrollTop();
		}

		if (scroll + this.$footerHeight / 2 >= delta) {
			if (!this.$footer.hasClass('_show')) {
				this.$footer.addClass('_show');
			}
		} else {
			if (this.$footer.hasClass('_show')) {
				this.$footer.removeClass('_show');
			}
		}
	},
};

module.exports = new MainPage();
